<script>
  import { onMount } from 'svelte';
  import GoogleTagManagerService from '../services/tag-manager.js';
  import LineruTagsService from '../services/lineru-tags.js';

  let code = ""

  let whatsappMessage = ""

  let facebookMessage = ""

  let twitterMessage = ""

  onMount(()=> {
		const res  = window.location.search;

		const urlParams = new URLSearchParams(res);

    code = urlParams.get('referral_code');

    whatsappMessage =`Mira 👀 , si llegas a necesitar dinero extra, en Lineru puedes pedirlo facilito. Allí es donde me prestan 👌.  Y este es mi código de referido: ${code}. Úsalo cuando pidas y ellos te dan 40% de descuento en intereses, administración y seguro en tu primer crédito 😎 . Mandales tu aplicación acá www.lineru.com`

    facebookMessage =`🤔 ¿A alguno le caería bien tener dinero extra a la mano? En Lineru pueden pedirlo facilito. Y con mi código de referido ${code}, tienen 40% de descuento en intereses, administración y seguro para su primer crédito👌. Lo piden en www.lineru.com. Ahí les dejo, ¡recomendado!🔥`

    twitterMessage =`%c2%bfConocen+Lineru%3f%f0%9f%a4%94Es+un+cr%c3%a9dito+por+internet%2c+perfecto+para+conseguir+dinero+r%c3%a1pido.+Ac%c3%a1+les+dejo+mi+c%c3%b3digo+de+referido%3a+${code}+%f0%9f%91%8c.+Aplicando+con+%c3%a9l+en+www.lineru.com%2c+les+dan+40%25+de+descuento+en+intereses%2c+administraci%c3%b3n+y+seguro+en+su+primer+cr%c3%a9dito.+%c2%a1Recomendado!+%f0%9f%94%a5`

  });

  function sharedFacebook() {
		FB.ui({
			method: 'share',
			href: 'https://www.lineru.com',
			quote: facebookMessage
    }, function(response){});

    GoogleTagManagerService.setTag(LineruTagsService.general().facebook);

    if(clevertap !== undefined) {
      clevertap.event.push("referred", {
        "referral channel": "Facebook",
        "referral code": code,
        "zinobe_product_name": "Lineru",
      });
    }
  }

  function goToWhatsapp() {
    window.open(`https://api.whatsapp.com/send?text=${whatsappMessage}`, '_blank');
    GoogleTagManagerService.setTag(LineruTagsService.general().whatsapp);

    if(clevertap !== undefined) {
      clevertap.event.push("referred", {
        "referral channel": "Whatsapp",
        "referral code": code,
        "zinobe_product_name": "Lineru",
      });
    }
  }

  function goToTwitter() {
    window.open(`https://twitter.com/intent/tweet?text=${twitterMessage}`, '_blank');
    GoogleTagManagerService.setTag(LineruTagsService.general().twitter);

    if(clevertap !== undefined) {
      clevertap.event.push("referred", {
        "referral channel": "Twitter",
        "referral code": code,
        "zinobe_product_name": "Lineru",
      });
    }
  }
</script>

<div class="pb-8">
  <div id="fold-2" style="background-image: url('images/fold-2/patrones-x.png');  background-repeat: repeat-x">
    <div class="container p-relative py-4">
      <img class="img_1 p-absolute" src="images/fold-2/forma-1.png" alt="">
      <div class="container py-5">
        <div class="d-grid grid-12 gap-0">
          <div class="col-12 pb-16 t-center">
            <h2 class="mb-4">
              Refiere como te quede más fácil
            </h2>
          </div>
          <div class="col-12 pt-lg-4 mb-10 t-md-center">
            <h3 class="mb-6">Opción 1</h3>
            <!-- <p>{whatsappMessage}</p> -->
            <h2 class="mb-8">Comparte tu código por redes:</h2>
            <p>Mientras <strong>más personas</strong> vean tu código, más referidos puedes acumular.
            </p>
          </div>
        </div>
        <div class="d-grid grid-12">
          <div class="col-12 col-lg-2"></div>
          <div class="d-grid grid-12 col-12 col-lg-8 justify-content-center align-content-center gap-5">
            <div class="col-12 col-lg-4 d-flex card bdr-radius-1 px-6 py-5">
                <img src="images/fold-2/whatsapp.svg" alt="whatsapp">
                <div class="align-self-center px-3">
                  <a
                    class="t-weight-bold"
                    href="/"
                    on:click|preventDefault={goToWhatsapp}
                    target="_blank">
                      Whatsapp
                  </a>
                </div>
            </div>
              <div class="col-12 col-lg-4 d-flex card bdr-radius-1 px-6 py-5">
                <img src="images/fold-2/facebook.svg" alt="">
                <div class="align-self-center px-3">
                  <a
                    class="t-weight-bold"
                    href="/"
                    on:click|preventDefault={sharedFacebook}
                    target="_blank">
                      Facebook
                  </a>
                </div>
              </div>
              <div class="col-12 col-lg-4 d-flex card bdr-radius-1 px-6 py-5">
                <img src="images/fold-2/twitter.svg" alt="">
                <div class="align-self-center px-3">
                  <a
                    class="t-weight-bold"
                    href="/"
                    on:click|preventDefault={goToTwitter}
                    target="_blank">
                      Twitter
                  </a>
                </div>
            </div>
          </div>
          <div class="col-12 col-lg-2"></div>
        </div>
      </div>
      <div class="container">
        <div class="t-center pt-6 pt-lg-10git st">
          <img src="images/fold-2/forma-2.png" alt="forma">
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .p-relative {
    position: relative;
  }
  .p-absolute {
    position: absolute;
  }
  .img_1{
    background-size: auto;
    top: 208px;
    left: 126px;
  }
  @media screen and (max-width: 568px){
    .img_1{
      background-size: auto;
      top: 175px;
      left: 200px;
    }
  }
  .card {
    box-shadow: 1px 8px 12px 2px #d3d3d3;
  }
</style>

